import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './BestCareSection.css';
import doctorVisit from '../images/gallery/Doctor Visit.jpg';

const BestCareSection = () => {
  return (
    <section className="best-care-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-4 mb-lg-0">
            <div className="section-badge">WE ARE THE</div>
            <h2>Best Home Care Services</h2>
            <p>
              At Aroghya Radham, we provide exceptional home care services in Guntur designed to meet your family's needs. Our dedicated team ensures comfort and
              safety, offering reliable support whenever you need it.
            </p>
            <p>
              If you're looking for home care services in Guntur, our dedicated team is here
              to help. We offer a range of home care services in Guntur residents trust,
              including professional home nursing services in Guntur. Our healthcare services are
              tailored to meet your unique needs, ensuring you receive the best support at home.
              As a reliable home health care agency, we provide medical home care services
              with compassion and expertise. With our 24/7 home care services, you can rest easy
              knowing your loved ones are in good hands.
            </p>
          </Col>
          <Col lg={6}>
            <div className="image-wrapper">
              <img 
                src={doctorVisit}
                alt="Best Home Care Services" 
                className="section-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BestCareSection;
